import React from 'react';

import pluralize from 'pluralize';
import { FieldPath } from 'react-hook-form';

import { parseDaysRange } from 'components/shared/DatePicker';
import { AdapterType } from 'utils/types';

import s from '../../index.module.css';
import { getFormattedDaysRange } from '../functions';
import { FieldValues, TPlanksDayPlankProps } from '../type';

export const NightsCountPlank = function <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ mode, field: { value } }: AdapterType<TFieldValues, TName> & TPlanksDayPlankProps) {
  const nightsCount = React.useMemo(() => {
    if (mode === 'single') return 0;

    if (!value?.start || !value?.end) return 0;
    return value.end - value.start;
  }, [mode, value]);

  const subtitle = React.useMemo(() => {
    if (!nightsCount) return 'Day room';
    return `${nightsCount} ${pluralize('night', nightsCount)}`;
  }, [nightsCount]);

  if (!value) return null;

  if (mode === 'single') {
    return (
      <div>
        <span>{`Day ${value}`}</span>
        <span className={s.subtitle}>
          {' '}
          {'\u0028'}
          {subtitle}
          {'\u0029'}
        </span>
      </div>
    );
  }

  return (
    <div>
      <span>{getFormattedDaysRange(parseDaysRange(value))}</span>
      <span className={s.subtitle}>
        {' '}
        {'\u0028'}
        {subtitle}
        {'\u0029'}
      </span>
    </div>
  );
};
